import { Routes } from '@angular/router';
import { AuthGuard } from './core/auth/guards/auth.guard';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'reservas'
  },
  {
    path: 'auth',
    loadChildren: () => import('./features/auth/auth.routes').then(m => m.authRoutes)
  },
  {
    // Declared before 'reservas' so the static segment wins over the reservations child routes.
    path: 'reservas/gestion-proveedor',
    loadChildren: () => import('./features/fulfillment/fulfillment.routes').then(m => m.fulfillmentRoutes),
    canActivate: [AuthGuard],
    title: 'Gestión con el proveedor'
  },
  {
    path: 'reservas/pagos-proveedores',
    loadChildren: () => import('./features/supplier-payables/supplier-payables.routes').then(m => m.supplierPayablesRoutes),
    canActivate: [AuthGuard],
    title: 'Pagos a proveedores'
  },
  {
    path: 'reservas',
    loadChildren: () => import('./features/reservations/reservations.routes').then(m => m.reservationsRoutes),
    canActivate: [AuthGuard],
    title: 'Gestión de Reservas'
  },
  {
    // Agencies is the only settings section today, so a bare /settings takes the operator
    // straight there instead of showing an empty landing page.
    path: 'settings',
    pathMatch: 'full',
    redirectTo: 'settings/agencies'
  },
  {
    path: 'settings/agencies',
    loadChildren: () => import('./features/agencies/agencies.routes').then(m => m.agenciesRoutes),
    canActivate: [AuthGuard],
    title: 'Configuración de Agencias'
  },
  {
    path: 'unauthorized',
    loadComponent: () =>
      import('./features/auth/presentation/pages/unauthorized/unauthorized.component').then(c => c.UnauthorizedComponent)
  },
  {
    path: '**',
    redirectTo: 'reservas'
  }
];
